/* eslint-disable @typescript-eslint/no-use-before-define */
import angular from 'angular'
import moment from 'moment-timezone'
import intl from 'react-intl-universal'

export default [
  '$scope',
  'timePickerService',
  schedulePublishTimePickerController,
]

function schedulePublishTimePickerController($scope, timePickerService) {
  this.intl = intl
  this.toggled = true
  this.toggle = function () {
    this.toggled = !this.toggled
  }.bind(this)
  this.firstPickTime = timePickerService.settingValueToMoment(
    timePickerService.DEFAULTS.alpha
  )
  this.secondPickTime = timePickerService.settingValueToMoment(
    timePickerService.DEFAULTS.beta
  )
  this.$onInit = function () {
    this.ngModel.$render = function () {
      const datum = this.ngModel.$viewValue
      if (angular.isDefined(datum)) {
        this.firstPickTime = timePickerService.settingValueToMoment(
          this.ngModel.$viewValue['sch-firstpick-time'],
          timePickerService.DEFAULTS.alpha
        )
        this.firstPickDay =
          this.ngModel.$viewValue['sch-firstpick-day'] ||
          timePickerService.DEFAULTS['alpha-day']
        this.firstPickSum = timePickerService.renderDateDelta(
          this.firstPickDay,
          this.firstPickTime
        )
        this.firstPickSum = moment(this.firstPickSum).utc(
          window.org_settings.timezone
        )

        this.firstPickSum = this.firstPickSum.calendar()
        let minutes = this.firstPickTime.getMinutes()
        minutes = String(minutes) === '0' ? '00' : String(minutes)
        this.firstPickTime = [this.firstPickTime.getHours(), minutes].join(':')
        this.secondPickTime = timePickerService.settingValueToMoment(
          this.ngModel.$viewValue['sch-secondpick-time'],
          timePickerService.DEFAULTS.beta
        )
        this.secondPickDay =
          this.ngModel.$viewValue['sch-secondpick-day'] ||
          timePickerService.DEFAULTS['beta-day']
        this.secondPickSum = timePickerService.renderDateDelta(
          this.secondPickDay,
          this.secondPickTime
        )
        this.secondPickSum = moment(this.secondPickSum).utc(
          window.org_settings.timezone
        )

        this.secondPickSum = this.secondPickSum.calendar()
        minutes = this.secondPickTime.getMinutes()
        minutes = String(minutes) === '0' ? '00' : String(minutes)
        this.secondPickTime = [this.secondPickTime.getHours(), minutes].join(
          ':'
        )
      }
      return datum
    }.bind(this)
  }.bind(this)
  this.update = function () {
    const datum = timePickerService.mergeDatumsIntoDatum(
      [
        this.ngModel.$viewValue,
        { 'sch-firstpick-time': this.firstPickTime },
        { 'sch-firstpick-day': this.firstPickDay },
        { 'sch-secondpick-time': this.secondPickTime },
        { 'sch-secondpick-day': this.secondPickDay },
      ],
      timePickerService.momentToSettingValue
    )
    this.ngModel.$setViewValue(datum)
  }.bind(this)
}
